import { createContext, PropsWithChildren, useCallback, useState } from "react";
import { v4 as uuidv4 } from "uuid";

export type MapRefreshKey =
  | "properties"
  | "warnings"
  | "documents"
  | "customMapsManual"
  | "customMapsImported"
  | "savedViews"
  | "searchResults";

type MapRefreshNonces = Record<MapRefreshKey, string>;

export type MapRefreshContextType = {
  nonces: MapRefreshNonces;
  refreshMap: (keys?: Array<MapRefreshKey>) => void;
};

const createNonces = (): MapRefreshNonces => ({
  properties: uuidv4(),
  warnings: uuidv4(),
  documents: uuidv4(),
  customMapsManual: uuidv4(),
  customMapsImported: uuidv4(),
  savedViews: uuidv4(),
  searchResults: uuidv4(),
});

export const MapRefreshContext = createContext<MapRefreshContextType>({
  nonces: createNonces(),
  refreshMap: () => {},
});

export const MapRefreshProvider = ({ children }: PropsWithChildren) => {
  const [nonces, setNonces] = useState(createNonces);

  const refreshMap = useCallback((keys?: Array<MapRefreshKey>) => {
    setNonces(prev => {
      if (keys) {
        const next = { ...prev };
        for (const key of keys) {
          next[key] = uuidv4();
        }
        return next;
      }
      return createNonces();
    });
  }, []);

  return (
    <MapRefreshContext.Provider value={{ nonces, refreshMap }}>
      {children}
    </MapRefreshContext.Provider>
  );
};
